// extracted by mini-css-extract-plugin
export var statItem = "_l2-1";
export var statsRow = "_l2-0";